/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, localDateString } from '../runtime';
import type { FileUrl } from './FileUrl';
import { FileUrlFromJSON, FileUrlFromJSONTyped, FileUrlToJSON } from './FileUrl';
import type { UpdatedAt } from './UpdatedAt';
import { UpdatedAtFromJSON, UpdatedAtFromJSONTyped, UpdatedAtToJSON } from './UpdatedAt';
import type { UpdatedBy } from './UpdatedBy';
import { UpdatedByFromJSON, UpdatedByFromJSONTyped, UpdatedByToJSON } from './UpdatedBy';

/**
 *
 * @export
 * @interface EpisodeAdminModel
 */
export interface EpisodeAdminModel {
    /**
     *
     * @type {string}
     * @memberof EpisodeAdminModel
     */
    id: string;
    /**
     *
     * @type {string}
     * @memberof EpisodeAdminModel
     */
    title: string;
    /**
     *
     * @type {number}
     * @memberof EpisodeAdminModel
     */
    episodeNumber: number;
    /**
     *
     * @type {string}
     * @memberof EpisodeAdminModel
     */
    showId: string;
    /**
     *
     * @type {Date}
     * @memberof EpisodeAdminModel
     */
    originalDate: Date;
    /**
     *
     * @type {string}
     * @memberof EpisodeAdminModel
     */
    createdBy: string;
    /**
     *
     * @type {Date}
     * @memberof EpisodeAdminModel
     */
    createdAt: Date;
    /**
     *
     * @type {UpdatedBy}
     * @memberof EpisodeAdminModel
     */
    updatedBy?: UpdatedBy;
    /**
     *
     * @type {UpdatedAt}
     * @memberof EpisodeAdminModel
     */
    updatedAt?: UpdatedAt;
    /**
     *
     * @type {string}
     * @memberof EpisodeAdminModel
     */
    content: string;
    /**
     *
     * @type {string}
     * @memberof EpisodeAdminModel
     */
    shortContent: string;
    /**
     *
     * @type {FileUrl}
     * @memberof EpisodeAdminModel
     */
    fileUrl?: FileUrl;
}

/**
 * Check if a given object implements the EpisodeAdminModel interface.
 */
export function instanceOfEpisodeAdminModel(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('title' in value)) return false;
    if (!('episodeNumber' in value)) return false;
    if (!('showId' in value)) return false;
    if (!('originalDate' in value)) return false;
    if (!('createdBy' in value)) return false;
    if (!('createdAt' in value)) return false;
    if (!('content' in value)) return false;
    if (!('shortContent' in value)) return false;
    return true;
}

export function EpisodeAdminModelFromJSON(json: any): EpisodeAdminModel {
    return EpisodeAdminModelFromJSONTyped(json, false);
}

export function EpisodeAdminModelFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): EpisodeAdminModel {
    if (json == null) {
        return json;
    }
    return {
        id: json['id'],
        title: json['title'],
        episodeNumber: json['episode_number'],
        showId: json['show_id'],
        originalDate: new Date(json['original_date']),
        createdBy: json['created_by'],
        createdAt: new Date(json['created_at']),
        updatedBy: json['updated_by'] == null ? undefined : UpdatedByFromJSON(json['updated_by']),
        updatedAt: json['updated_at'] == null ? undefined : UpdatedAtFromJSON(json['updated_at']),
        content: json['content'],
        shortContent: json['short_content'],
        fileUrl: json['file_url'] == null ? undefined : FileUrlFromJSON(json['file_url']),
    };
}

export function EpisodeAdminModelToJSON(value?: EpisodeAdminModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        id: value['id'],
        title: value['title'],
        episode_number: value['episodeNumber'],
        show_id: value['showId'],
        original_date: localDateString(value['originalDate']),
        created_by: value['createdBy'],
        created_at: value['createdAt'].toISOString(),
        updated_by: UpdatedByToJSON(value['updatedBy']),
        updated_at: UpdatedAtToJSON(value['updatedAt']),
        content: value['content'],
        short_content: value['shortContent'],
        file_url: FileUrlToJSON(value['fileUrl']),
    };
}
